import { render, staticRenderFns } from "./reviewHistoryList.vue?vue&type=template&id=ece5871a&scoped=true&"
import script from "./reviewHistoryList.vue?vue&type=script&lang=js&"
export * from "./reviewHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./reviewHistoryList.vue?vue&type=style&index=0&id=ece5871a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece5871a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ece5871a')) {
      api.createRecord('ece5871a', component.options)
    } else {
      api.reload('ece5871a', component.options)
    }
    module.hot.accept("./reviewHistoryList.vue?vue&type=template&id=ece5871a&scoped=true&", function () {
      api.rerender('ece5871a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chatbotManagement/reviewHistoryList.vue"
export default component.exports